import React, {Component} from 'react'

class ShortAdminInfo extends Component {

    render() {
        const { data } = this.props;
        
        if (!data) return null;

        let Elements = Object.keys(data).map(
            function(element) {
                return <li key={element}><b>{element}</b>: {data[element]}</li>
            });


        return (
            <ul className="admin-info">
                {Elements}
            </ul>
        )
    }
}

export default ShortAdminInfo;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserInfoTooltip/ShortAdminInfo.js